module.exports = __webpack_public_path__ + "img/r-118.98de8f34.jpg";